import React from 'react';
import ReactDOM from 'react-dom';
import PriceTableSelector from './components/PriceTableSelector';
import PriceTableAll from './components/PriceTableAll';
import TrialForm from './components/TrialForm'; 
import ContactForm from './components/ContactForm'; 
import GroupLessonForm from './components/GroupLessonForm'; 
import CoursePlanDisplay from './components/CoursePlanDisplay';
import DavidGroupLessonButton from './components/DavidGroupLessonButton';
import SchoolList from './components/SchoolList';
import InstructorList from './components/InstructorList';
import CaseStudyComponent from './components/CaseStudyComponent';
import CorporateLeadForm from './components/CorporateLeadForm';
import CorporateTrialForm from './components/CorporateTrialForm';
import Popup from './components/Popup';
import DiscountCountdown from './components/DiscountCountdown'; 
import TableOfContents from './components/TableOfContents'; 

window.renderTrialForm = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<TrialForm />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderCorporateTrialForm = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<CorporateTrialForm />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};


window.renderContactForm = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<ContactForm />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderPriceTableSelector = function(elementId, initialCourse = "default") {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<PriceTableSelector initialCourse={initialCourse} />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderPriceTableAll = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<PriceTableAll />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderCoursePlanDisplay = function(elementId, course) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<CoursePlanDisplay selectedCourse={course} />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderCaseStudyComponent = function(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(<CaseStudyComponent />, element);
  } else {
    console.error(`Element with ID ${elementId} not found`);
  }
};

window.renderGroupLessonForm = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<GroupLessonForm />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderDavidGroupLessonButton = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<DavidGroupLessonButton />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderSchoolList = function(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<SchoolList />, element);
    } else {
        console.error(`Element with ID ${elementId} not found`);
    }
};

window.renderInstructorList = function(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(<InstructorList />, element);
  } else {
    console.error(`Element with ID ${elementId} not found`);
  }
};

window.renderCorporateLeadForm = function(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(<CorporateLeadForm />, element);
  } else {
    console.error(`Element with ID ${elementId} not found`);
  }
};


window.renderDiscountCountdown = function(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(<DiscountCountdown />, element);
  } else {
    console.error(`Element with ID ${elementId} not found`);
  }
};

window.renderTableOfContents = function(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(<TableOfContents />, element);
  } else {
    console.error(`Element with ID ${elementId} not found`);
  }
};


document.addEventListener('DOMContentLoaded', () => {
  const targetDiv = document.createElement('div');
  targetDiv.id = 'campaign-popup';
  document.body.appendChild(targetDiv);

  ReactDOM.render(
    <Popup excludePages={['/contact', '/term','/policy','/legal','/register',',/corporation','/faq','/corporate-client',',/thankyou','/thankscontact','/thankyou-corporate','/lp/spring2025']} />,
    targetDiv
  );
});




